<template>
    <div>
        <div class="cb">
            <div :style="`background-image: url('${user.thumb}')`" class="avatar pr fl">
                <router-link to="users/avatar" class="avatar-mask">
                    <i class="icon-reply"></i>
                    更换头像
                </router-link>
            </div>
            <div class="fl">
                <div class="nickname">{{user.nico}}</div>
                <router-link to="users/update" class="button">修改资料</router-link>
                <!--<span class="button">个人空间</span>-->
                <router-link :to="`spaces/${user.id}`" class="button">个人空间</router-link>
            </div>
        </div>

        <div class="account-box">
            <div class="account-title">
                <i class="icon-safe"></i>
                账号安全
            </div>
            <div class="account-phone cb">
                <div :class="`account-icon-box im${user.phone ? ' ig' : ''}`">
                    <i class="icon-phone"></i>
                </div>

                <div class="account-tip-box im">
                    <div class="account-tip-main">
                        <div>{{user.phone ? `手机已绑定(+${user.nation} ${user.phone})` : '我的手机'}}</div>
                        <div class="account-tip">绑定手机后即可使用手机号登录</div>
                    </div>
                    <div class="account-button">
                        <router-link v-if="user.phone" to="users/phone/modify" class="button">更改手机</router-link>
                        <span v-if="!user.phone"
                              @click="$store.state.sign.phone_box_show = true"
                              class="button">绑定手机
                        </span>
                    </div>
                </div>
            </div>
            <div class="account-phone cb">
                <div :class="`account-icon-box im${user.has_psw ? ' ig' : ''}`">
                    <i class="icon-password"></i>
                </div>

                <div class="account-tip-box im">
                    <div class="account-tip-main">
                        <div>{{user.psw ? '已' : '未'}}设置密码</div>
                        <div class="account-tip">设置密码后即可使用密码登录</div>
                    </div>
                    <div class="account-button">
                        <router-link v-if="!user.has_psw" to="users/psw/bind" class="button">设置密码</router-link>
                        <router-link v-if="user.has_psw" to="users/select" class="button">更改密码</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="account-box">
            <div class="account-title">
                <i class="icon-third"></i>
                第三方账号绑定
            </div>
            <div class="account-phone cb">
                <div :class="`account-icon-box im${user.has_qq ? ' ig' : ''}`">
                    <i class="icon-qq"></i>
                </div>
                <div class="account-tip-box im">
                    <div class="account-tip-main">
                        <!--<div>{{user.has_qq ? '已' : '未'}}</div>-->
                        <div v-show="user.has_qq">{{user.qq_name || '已绑定QQ'}}</div>
                        <div v-show="!user.has_qq">未绑定QQ</div>
                        <div class="account-tip">绑定QQ帐号，使用QQ帐号便捷登录</div>
                    </div>
                    <div class="account-button">
                        <span v-show="!user.has_qq" @click="qq_show = true" class="button">立即绑定</span>
                        <span v-show="user.has_qq" @click="unBind('qq')" class="button">解除绑定</span>
                    </div>
                </div>
            </div>

            <div class="account-phone cb">
                <div :class="`account-icon-box im${user.has_wx ? ' ig' : ''}`">
                    <i class="icon-wechat"></i>
                </div>

                <div class="account-tip-box im">
                    <div class="account-tip-main">
                        <div v-show="user.has_wx">{{user.wx_name || '已绑定微信'}}</div>
                        <div v-show="!user.has_wx">未绑定微信</div>
                        <div class="account-tip">绑定微信帐号，使用微信帐号便捷登录</div>
                    </div>
                    <div class="account-button">
                        <span v-show="!user.has_wx" @click="wx_show = true" class="button">立即绑定</span>
                        <span v-show="user.has_wx" @click="unBind('wx')" class="button">解除绑定</span>
                    </div>
                </div>
            </div>

            <div class="account-phone cb">
                <div :class="`account-icon-box im${user.has_wb ? ' ig' : ''}`">
                    <i class="icon-weibo"></i>
                </div>

                <div class="account-tip-box im">
                    <div class="account-tip-main">
                        <div v-show="user.has_wb">{{user.wb_name || '已绑定微博'}}</div>
                        <div v-show="!user.has_wb">未绑定微博</div>
                        <div class="account-tip">绑定微博帐号，使用微博帐号便捷登录</div>
                    </div>
                    <div class="account-button">
                        <span v-show="!user.has_wb" @click="wb_show = true" class="button">立即绑定</span>
                        <span v-show="user.has_wb" @click="unBind('wb')" class="button">解除绑定</span>
                    </div>
                </div>
            </div>

        </div>

        <!--第三方登陆组件-->
        <div class="sign-frame-box im" v-if="qq_show || wb_show || wx_show">
            <div class="sign-frame-main sign-frame-qq" v-if="qq_show">
                <iframe @load="signFrameLoad" ref="frame" class="sign-frame" src="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101285374&redirect_uri=https://www.vhiphop.com/more-sign"></iframe>
                <div class="qq-frame-header"></div>
                <i @click="qq_show = false" class="icon-close frame-qq-icon"></i>
            </div>

            <div class="sign-frame-main" v-if="wb_show">
                <iframe @load="signFrameLoad" ref="frame" class="sign-frame" src="https://api.weibo.com/oauth2/authorize?client_id=1628876205&response_type=code&redirect_uri=https://www.vhiphop.com/more-sign"></iframe>
                <i @click="wb_show = false" class="icon-close frame-wb-icon"></i>
            </div>

            <div class="sign-frame-main sign-frame-wechat" v-if="wx_show">
                <iframe @load="signFrameLoad" ref="frame" class="sign-frame" src="https://open.weixin.qq.com/connect/qrconnect?appid=wx13820b959172c57f&redirect_uri=https%3A%2F%2Fwww.vhiphop.com%2Fmore-sign&response_type=code&scope=snsapi_login&self_redirect=true&style=white#wechat_redirect"></iframe>
                <i @click="wx_show = false" class="icon-close frame-qq-icon"></i>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data: () => ({
            qq_show: false,
            wb_show: false,
            wx_show: false,
        }),
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        methods: {
            signFrameLoad() {
                let type, code;

                try {
                    code = this.$refs['frame'].contentWindow.location.search.split('?code=')[1];

                } catch (e) {
                    return false;
                }

                this.is_signing = true;
                if (this.qq_show) {
                    this.qq_show = false;
                    type = 'qq';
                } else if (this.wx_show) {
                    this.wx_show = false;
                    code = code.split('&state=')[0];// 没有state参数 所以去掉后缀
                    type = 'wx';
                } else {
                    this.wb_show = false;
                    type = 'wb';
                    if (!code) return;
                }

                this.api.post(`users/${type}/bind`, {code}).then(e => {
                    this.user[`has_${type}`] = true;
                    this.user[`${type}_name`] = e.name;
                }, e => {
                    this.alert.err(e.message);
                });
            },
            unBind(e) {// 解除绑定
                if (!this.user.phone) return this.alert.err('请先绑定手机');
                if (this.is_loading) return;
                this.confirm({
                    title: '解除绑定',
                    content: `确认要解除与该第三方账号的关联吗?`,
                    next() {
                        this.is_loading = true;
                        this.api.get(`users/${e}/del`).then(() => {
                            this.user[`has_${e}`] = false;
                            this.user[`${e}_name`] = '';
                            this.is_loading = false;
                        }, e => {
                            this.alert.err(e.message);
                        });
                    }
                })
            },
        }
    }
</script>

<style scoped>
    @import "../../../static/css/views/user/home.css";
</style>


// WEBPACK FOOTER //
// src/views/user/Home.vue